import "./QuestionPreview.scss";

import { CardHelper, QuestionTakingContainerSettings, questionTakingContainer } from "@teams/cards";
import { Question, QuestionType } from "@teams/types";
import React, { useMemo } from "react";

import { useTheme } from "../../../_shared/state/ThemeProvider";

type Props = {
  question: Question<QuestionType>;
  settings?: QuestionTakingContainerSettings;
  index: number;
  onClick: () => void;
};

export const QuestionPreview: React.FC<Props> = ({ question, index, settings, onClick }) => {
  const { hostConfig } = useTheme();

  const element = useMemo(() => {
    const container = questionTakingContainer(question, index, settings || {});

    const card = CardHelper.newCard();
    card.addItem(container);
    card.hostConfig = hostConfig;

    const result = card.render() as HTMLElement;
    result.style.padding = "0";
    return result;
  }, [question, index, settings, hostConfig]);

  return (
    <div
      className="question-preview"
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: element.outerHTML }}
    />
  );
};
